import { arrayOf, func, object } from 'prop-types';
import React from 'react';

import TextFieldArea from 'components/TextFieldArea';
import ContentColumns from '../../components/ContentColumns';
import { descriptionText } from './View.less';
import { path } from 'ramda';
import InfoDialog from '../../../InfoDialog';

const View1 = ({ documents }, { fm, fmString, onChange, formValues }) => {
  const onChangeText = name => event => {
    const eventValue = path(['currentTarget', 'value'], event);
    onChange({ [name]: eventValue });
  };

  const getValue = name => path(['rehab2', name], formValues) || '';

  const fsmcId = path(['rehab1', 'fsmc'], formValues);
  const fsmcDoc = fsmcId ? documents.find(d => d.documentId === fsmcId) : null;

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm('onlineRehabilitation.rehab2.1.welcome')}</h2>
            <br />
            <div>{fm('onlineRehabilitation.rehab2.1.text')}</div>
            <br />
            <br />
            <h3>{fm('onlineRehabilitation.rehab2.1.whenAreYouFatigued')}</h3>
            <div className={descriptionText}>{fm('onlineRehabilitation.rehab2.1.whenAreYouFatiguedDescription')}</div>
            <TextFieldArea
              editing
              input={{
                name: 'whenAreYouFatigued',
                onChange: onChangeText('whenAreYouFatigued'),
                value: getValue('whenAreYouFatigued'),
              }}
              localeMessage={fmString}
              hintLocale={'onlineRehabilitation.rehab2.1.whenAreYouFatiguedPlaceholder'}
              rows={3}
              viewStyle={{ width: '100%' }}
            />
            <br />
            <br />
            <h3>{fm('onlineRehabilitation.rehab2.1.whatCausesTheFatigue')}</h3>
            <div className={descriptionText}>{fm('onlineRehabilitation.rehab2.1.whatCausesTheFatigueDescription')}</div>
            <TextFieldArea
              editing
              input={{
                name: 'whatCausesTheFatigue',
                onChange: onChangeText('whatCausesTheFatigue'),
                value: getValue('whatCausesTheFatigue'),
              }}
              localeMessage={fmString}
              hintLocale={'onlineRehabilitation.rehab2.1.whatCausesTheFatiguePlaceholder'}
              rows={3}
              viewStyle={{ width: '100%' }}
            />
            <br />
            <br />
            <h3>{fm('onlineRehabilitation.rehab2.1.factorsToEaseFatigue')}</h3>
            <div className={descriptionText}>{fm('onlineRehabilitation.rehab2.1.factorsToEaseFatigueDescription')}</div>
            <TextFieldArea
              editing
              input={{
                name: 'factorsToEaseFatigue',
                onChange: onChangeText('factorsToEaseFatigue'),
                value: getValue('factorsToEaseFatigue'),
              }}
              localeMessage={fmString}
              hintLocale={'onlineRehabilitation.rehab2.1.factorsToEaseFatiguePlaceholder'}
              rows={3}
              viewStyle={{ width: '100%' }}
            />
            <br />
            <br />
            <span>{fm('onlineRehabilitation.rehab2.1.text2')}</span>{' '}
            {fsmcDoc ? (
              <InfoDialog type="fsmc" document={fsmcDoc} fm={fm} />
            ) : (
              fm('onlineRehabilitation.surveyDataMissing')
            )}{' '}
            <span>{fm('onlineRehabilitation.rehab2.1.text3')}</span>
          </div>
        }
      />
    </React.Fragment>
  );
};

View1.contextTypes = {
  fm: func,
  fmString: func,
  onChange: func,
  formValues: object,
};
View1.propTypes = {
  documents: arrayOf(object),
};

export default View1;
